export default "__VITE_ASSET__0c0e59c1__"